module.exports = __webpack_public_path__ + "static/media/indes.4733c689.png";